export const getShortName = (fullName?: string) => {
  if (!fullName) {
    return "Nome do Talento";
  }
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0];
  }
  return `${parts[0]} ${parts[parts.length - 1]}`;
};
